rs.module("controls/framework/ag/agNameValueHelper",

    [],

    function () {

        // Marker so we know when an array actually represents name\value data.  This must stay in sync with AgJsonNameValueHelper
        var _nameValueMarker = "_nv";

        var valueIndex = 0;
        var nameIndex = 1;
        var markerIndex = 2;

        //
        // Indicates if the given value is a name\value
        //
        function isNameValue(value) {
            return value instanceof Array && value[markerIndex] == _nameValueMarker;
        }

        //
        // Get the name portion of the name\value pair
        //
        function getName(nameValuePair) {
            if (!isNameValue(nameValuePair)) {
                throw new Error(`"The value '${nameValuePair}' is not a name-value."`);
            }

            return nameValuePair[nameIndex];
        }

        //
        // Get the value portion of the name\value pair
        //
        function getValue(nameValuePair) {
            if (!isNameValue(nameValuePair)) {
                throw new Error(`"The value '${nameValuePair}' is not a name-value."`);
            }

            return nameValuePair[valueIndex];
        }

        // Exported public API
        var exports = {
            isNameValue,
            getName,
            getValue
        };

        return exports;
    }
);
